module.exports = __webpack_public_path__ + "img/16d001-36.3a7049b4.png";